import React from 'react';
import styled from '@emotion/styled';

const StyledSharedTab = styled.div`
  position: absolute;
  right: -15px;
  width: 15px;
  bottom: 20px;
`;

const StyledSharedTabOption = styled.div`
  font-size: 12px;
`;

export default function SocialSharing() {
  return (
    <>
      <StyledSharedTab>
        <StyledSharedTabOption
          style={{
            color: 'rgb(255, 255, 255)',
            backgroundColor: 'rgb(85, 172, 238)',
          }}
        >
          <i className='fab fa-twitter'></i>
        </StyledSharedTabOption>
        <StyledSharedTabOption
          style={{
            color: 'rgb(255, 255, 255)',
            backgroundColor: 'rgb(59, 87, 157)',
          }}
        >
          <i className='fab fa-facebook-f'></i>
        </StyledSharedTabOption>
        <StyledSharedTabOption
          style={{
            color: 'rgb(255, 255, 255)',
            backgroundColor: 'rgb(36, 133, 175)',
          }}
        >
          <i className='fab fa-linkedin-in'></i>
        </StyledSharedTabOption>
        <StyledSharedTabOption
          style={{
            color: '#111111',
            backgroundColor: '#eeeeee',
          }}
        >
          <i className='far fa-share-square'></i>
        </StyledSharedTabOption>
      </StyledSharedTab>
    </>
  );
}
